import React from "react";
import PropTypes from "prop-types"
import {Table} from 'antd';
import {defaultPagination} from "../../util/Util"


const SelectionTableDetail = ({dataSource, onSelectChange, loading}) => {
    console.log("datasource", dataSource);
    const columns = [
        {title: 'Description', dataIndex: 'description'},
        {title: 'Description Long', dataIndex: 'longDescriptionEn'},
        {title: 'Counts', dataIndex: 'count'},
        {title: 'Share %', dataIndex: 'share'},
    ];

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            if (selectedRowKeys.length > 0) onSelectChange(selectedRows)
        }
    };

    return (
        <Table
            dataSource={dataSource}
            loading={loading}
            columns={columns}
            size="small"
            bordered
            rowKey={record => record.id}
            rowSelection={rowSelection}
            pagination={defaultPagination()}
        />
    );
};
SelectionTableDetail.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired
};

export default SelectionTableDetail



// WEBPACK FOOTER //
// ./src/js/browse/selection/SelectionTableDetail.js